import "./styles/main.scss";
import "mapbox-gl/dist/mapbox-gl.css";
import Index from "./pages";
import mapboxgl from "mapbox-gl/dist/mapbox-gl";
// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass =require("worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker").default;

function App() {
  return (
    <div className="App">
      <Index />
    </div>
  );
}

export default App;
